import { Flame, Table, Toilet, Mountain as Rock, RadioTower, CableCar, Footprints, Trees, Building2, Mountain, MapPin, Droplets, Tent, Eye, ParkingSquare, TriangleAlert, Waves, Snowflake, Home, Flag, type LucideIcon } from "lucide-vue-next";

// Сопоставление OSM-kind бэкенда с иконкой. Неизвестный kind - MapPin.
const ICONS: Record<string, LucideIcon> = {
  peak: Mountain, volcano: Mountain, hill: Mountain, ridge: Mountain, mountain_pass: Flag, saddle: Flag,
  spring: Droplets, drinking_water: Droplets, water_point: Droplets, water_tap: Droplets, water_well: Droplets, waterfall: Droplets,
  shelter: Tent, alpine_hut: Tent, wilderness_hut: Tent, camp_site: Tent, mountain_rescue: Tent, rescue_hut: Home,
  viewpoint: Eye, parking: ParkingSquare, danger: TriangleAlert,
  lake: Waves, water: Waves, glacier: Snowflake,
  firepit: Flame, picnic_table: Table, toilets: Toilet, cave_entrance: Rock, rock: Rock, tower: RadioTower,
  cable_car_station: CableCar, ford: Footprints, grassland: Trees, wetland: Waves,
  suburb: Building2, neighbourhood: Building2, valley: Mountain, gorge: Mountain, region: MapPin,
  village: Home, town: Home, city: Home, hamlet: Home, locality: Home,
};
export const kindIcon = (osmKind: string): LucideIcon => ICONS[osmKind] ?? MapPin;
// Есть ли у вида собственный глиф (не общий MapPin) - для пина выбранной точки на карте.
export const hasKindGlyph = (osmKind: string): boolean => ICONS[osmKind] != null && ICONS[osmKind] !== MapPin;
// Ключи словаря search.kinds (ru/en/kk).
export const KNOWN_KINDS = Object.keys(ICONS);

// Подпись kind: перевод из search.kinds, иначе сам kind без подчёркиваний.
export const kindLabel = (osmKind: string, t: (k: string) => string, te: (k: string) => boolean): string =>
  te(`search.kinds.${osmKind}`) ? t(`search.kinds.${osmKind}`) : osmKind.replace(/_/g, " ");
